module.exports = __webpack_public_path__ + "img/couple-on-computer.8d8a062.jpg";